import axios from 'axios'

const CART_ENDPOINT = '/api/v1/cart'

const request = axios.create({
  baseURL: window.env && window.env.baseHost
})

export const getCart = async () =>
  (await request.get(CART_ENDPOINT)).data

export const getCartUniqueProductsCount = async () =>
  (await request.get(`${CART_ENDPOINT}/unique-products-count`)).data

export const putProductsInCart = async (data) =>
  (await request.post(CART_ENDPOINT, data)).data

export const removeProductFromCart = productId =>
  request.delete(`${CART_ENDPOINT}/${productId}`)

export const fetchCartShipping = async (postalCode = '') =>
  (await request.get(`/api/v1/shipments/${postalCode}`)).data
